/**
 * NotificationUsersRedirect (1.34.0)
 *
 * Аналог NotificationOrderRedirect для событий уровня пользователя
 * (сейчас только user_deletion_requested).
 *
 * Логика:
 *   • company_admin → /admin/users (список сотрудников, там помечены те,
 *     у кого есть активный запрос на удаление)
 *   • остальные роли → / (главная)
 *
 * Если роль ещё резолвится — показываем Spinner.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '../design-system/atoms/Spinner';
import { useCompanyRole } from '../domains/auth/companyRole';

export function NotificationUsersRedirect() {
  const { companyRole, loading } = useCompanyRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    const target = companyRole === 'company_admin' ? '/admin/users' : '/';
    navigate(target, { replace: true });
  }, [companyRole, loading, navigate]);

  return <Spinner label="Открываем список сотрудников..." />;
}
